<template  >


  <v-container style="width:100vw;height:100vh;background: #373737;" >


    <v-row align="center" justify="center" class="mx-auto" style="margin-top:100px;max-width:1800px;">
      <v-btn dark class="text-lowercase font-weight-light" router
             :to="'/admin'" tile text>
        Stats
      </v-btn>

      <v-btn dark router :to="'/db-admin'" class="text-lowercase font-weight-light"  text>
        DB
      </v-btn>
      <v-btn dark router :to="'/admin_payouts'" class="text-lowercase font-weight-light"  text>
        Payouts
      </v-btn>
      <v-btn dark router :to="'/admin_spons'" class="text-lowercase font-weight-light"  text>
        Spons
      </v-btn>

      <v-col cols="12" align="center">
        <v-card >
          <v-card-text style="max-width:800px;">
            <v-row>

              <v-col cols="3">
                <v-text-field v-model="campaign" label="Kampanj">

                </v-text-field>
              </v-col>
              <v-col cols="5">
                <v-menu
                    ref="menu"
                    v-model="date_menu"
                    :close-on-content-click="false"
                    :return-value.sync="date_range"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="date_range"
                        clearable
                        label="Datum"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="date_range"
                      range
                      no-title
                      scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="date_menu = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date_range)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="2">
                <v-btn @click="get_spons_data" :disabled="campaign===''" dark style="margin-top:10px;" color="pink">Uppdatera</v-btn>
              </v-col>
            </v-row>


          </v-card-text>
          <v-card-text >
            <v-row>
              <v-col>STREAMER</v-col>
              <v-col>VISNINGAR</v-col>
              <v-col>INTERAKTIONER</v-col>
              <v-col>KLICK</v-col>



            </v-row>
            <v-row>
              <v-col><small>Totalt:</small></v-col>
              <v-col>{{ total_views }}</v-col>
              <v-col>{{ total_interactions }}</v-col>
              <v-col>{{ total_clicks}}</v-col>



            </v-row>

          </v-card-text>

          <v-card-text class="py-0" v-for="(spons,index) in spons_data" :key="index">
            <v-row :style="{'background':index%2===0?'#f5f5f5':'white'}">
              <v-col>{{spons.STREAMER}}</v-col>
              <v-col>{{spons['TOTAL(CHAT_COUNT)']}}</v-col>
              <v-col>{{spons['TOTAL(VOTE_COUNT)']}}</v-col>
              <v-col>{{spons['CLICKS']}}</v-col>



            </v-row>

          </v-card-text>








        </v-card>
      </v-col>



    </v-row>




  </v-container>

</template>

<script>


export default {
  name: "Admin-spons",
  components:{},

  data:function(){
    return{
      date_range:["2019-01-01",(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)],
      date_menu:false,
      campaign:"6",
      spons_data:[],
      total_views:0,
      total_interactions:0,
      total_clicks:0


    }
  },
  methods:{

    filter_change(){
      this.get_data();
    },
    set_default_dates:function(){
      this.date_range[0]="2019-01-01";
      this.date_range[1]=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    },







    get_spons_data:function(){
      this.total_views=0;
      this.total_interactions=0;
      this.total_clicks=0;
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/getSponsData?';

      let params = 'CAMPAIGN='+this.campaign+"&START="+this.date_range[0]+"&END="+this.date_range[1];
      http.open('POST', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      let self=this;
      http.onreadystatechange = function() {//Call a function when the state changes.

        if(http.readyState === 4 && http.status === 200){
          let data=JSON.parse(http.responseText);
          let streamer_to_index={};
          for(let i=0;i<data.views.length;i++){
              data.views[i].CLICKS=0;
              streamer_to_index[data.views[i]["STREAMER"]]=i;
              self.total_views+=data.views[i]["TOTAL(CHAT_COUNT)"];
              self.total_interactions+=data.views[i]["TOTAL(VOTE_COUNT)"];

          }
          for(let i=0;i<data.clicks.length;i++){
            self.total_clicks+=data.clicks[i]["CLICKS"];

            if(data.clicks[i]["STREAMER"] in streamer_to_index){
              data.views[streamer_to_index[data.clicks[i]["STREAMER"]]].CLICKS=data.clicks[i]["CLICKS"];
            }else{
              data.views.push({
                "STREAMER":data.clicks[i]["STREAMER"],
                "TOTAL(CHAT_COUNT)":0,
                "TOTAL(VOTE_COUNT)":0,
                "CLICKS":data.clicks[i]["CLICKS"]
              })
            }
          }


          self.spons_data=data.views;

        }
        else if(http.readyState === 4 && http.status !== 200){
          self.spons_data=[];
        }




      };
      http.send(params);
    }


  },
  computed:{
  },
  watch: {
    date_range:function(){
      if(this.date_range===null){
        this.date_range=["",""];
        this.set_default_dates();
      }
    }

  },
  mounted:function(){
    let self=this;
    setTimeout(function(){
      if(!self.$store.state.STREAMER.IS_ADMIN){
        self.$router.push(`/404`)

      }
    },1000);


  }

}
</script>

<style >
.v-tabs-bar{
  background: transparent !important;
}

.theme--dark.v-data-table tbody tr:hover{
  background: rgba(255,255,255,0.1) !important;
}

.fillme{
  background: black;
}

.text-start{
  white-space: nowrap;
  font-size:14px !important;
}

.v-data-table__wrapper{
  min-height:400px;
}
</style>
